
import { formatDistanceToNow,isToday,format,isValid   } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
export function currency(value) {
  return Number(value).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
}
export function timeAgo(date) {
  // Transformando timestamp para objeto Date
  const dateObj = new Date(date);
  if (!isValid(dateObj)) {
      return 'Data inválida'; // Verifica se a data é válida
  }
  const timeAgoText = formatDistanceToNow(dateObj, { addSuffix: true, locale: ptBR });
  const todayText = isToday(dateObj) ? " - hoje" : ` - ${format(dateObj, 'dd/MM/yyyy', { locale: ptBR })}`;
  return timeAgoText + todayText;
}




export function validDateCupom(date) {
  if (!date) return false; // Retorna false se a data for nula ou indefinida

  const dt = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Isso irá ignorar a hora atual e comparar somente a data

  return dt >= today;
}




export function valueToRate(value) {
  const rates = ["Ruim", "Regular", "Bom", "Ótimo", "Excelente"];

  return rates[value - 1];
}



export function textEllipsis(text, limit = 15) {
  const words = text.split(" ");
  if (words.length <= limit) {
    return text;
  }

  const limited = words.slice(0, limit);
  return limited.join(" ") + "...";
}

export const routes = {
  login: {
    client: "/login",
    editor: "/login",
    admin: "/login",
  },
  signup: {
    client: "/user",
    editor: "/editor",
    admin: "/admin",
  },
  logout: {
    client: "/logout",
    editor: "/logout",
    admin: "/logout",
  },
};
